// the endpoint to get the requested data
export const NODE_URL = 'https://ca7c32vkq5.execute-api.us-east-2.amazonaws.com/HIVE-STAGE/todo';
// export const NODE_URL = 'http://localhost:4000/todo';
 
//methods to be called to get the data from db
export const todo_apiIndex = {
    module: {
        todo: 1,
        teamMembers: 2,
        concerns: 4,
        faq: 3
    },
    methodname: {
        getMyTodo: 1,
        searchMyTodo: 2,
        sortMyTodo: 3,
        filterMyTodo: 4,
        deleteMyTodo: 8,
        postMyTodo: 6,
        getTodoFilterData: 5,
        updateMyTodo: 7,
        getTeamMembers: 9,
        getTeamMemberTodo: 10,
        searchTeamMember: 11,
        sortTeamMember: 12,
        getFilterData: 13,
        filterTeamMembers: 14,
        getConcerns: 21,
        postConcern: 22,
        updateConcern: 23,
        deleteConcern: 24,
        viewConcern: 26,
        getConcernByID: 27,
        getTeamConcerns: 25,
        getDepartment: 28,
        getPeople: 29,
        updateViewConcern: 30,
        getFAQ: 15,
        getFAQByID: 19,
        postFAQ: 16,
        updateFAQ: 17,
        deleteFAQ: 18,
        getCategories: 20
    }
};

export const sessionEndpoints = {
    getSession: `/app/v2/sessions/softskill`,
    postSession: `/app/v2/sessions/softskill`,
    getParticipants: `/app/v2/sessions/softskill/participants`,
    getEmployeeDetails: `/app/v2/sessions/user`,
    postParticipants: `/app/v2/sessions/softskill/register`,
    getDomain: `/app/v2/domain`
}